import { Helmet } from 'react-helmet';
import { FinanceSettingsContainer } from '../components/finance-settings.container';

interface FinanceSettingsProps {}

export const FinanceSettings: React.FC<FinanceSettingsProps> = () => {
  return (
    <>
      <Helmet>
        <title>Finance - Settings</title>
      </Helmet>
      <FinanceSettingsContainer />
    </>
  );
};
